import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-modify-amount',
  templateUrl: './modify-amount.component.html',
  styleUrls: ['./modify-amount.component.scss']
})
export class ModifyAmountComponent {
  @Input() set offer (offerDetails : any){
    this.offerDetails = offerDetails;
    this.amount = offerDetails?.OfferAmt ?? offerDetails?.Amount ?? 0;
  };
  offerDetails! : any;
  amount!: number;
  // amountValid: boolean = true;
  @Output() amountValid = new EventEmitter<boolean>();
  @Output() amountChange = new EventEmitter<number>();


  validationCheck() {
    this.amountValid.emit(this.amount !== 0);
  }

  modifyAmount(){
    this.amountChange.emit(this.amount);
  }

  cancelModifyClick(){
    this.amountChange.emit();
  }
  
}
